// @flow strict

//$FlowFixMe[nonstrict-import]
import type {State} from 'src/reducers';

export const selectI18NSelectedLanguage = (state: State): string =>
  state.agentSettings.i18NSelectedLanguage;
